import { useTranslation } from 'react-i18next'

const Content = () => {
  const { t } = useTranslation(['common', 'pages', 'errors', 'forms', 'badges', 'navigation'])

  return (
    <div>
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900">{t('pages:contentHeading')}</h1>
        <p className="text-gray-600 mt-2">{t('pages:contentSubHeading')}</p>
      </div>

      <div className="space-y-6">
        <div className="card">
          <h2 className="text-xl font-bold mb-4">{t('pages:legalPrivacy')}</h2>
          <p className="text-gray-600">{t('pages:legalPrivacyBody')}</p>
        </div>

        <div className="card">
          <h2 className="text-xl font-bold mb-4">{t('pages:socialLinks')}</h2>
          <p className="text-gray-600">{t('pages:socialLinksBody')}</p>
        </div>

        <div className="card">
          <h2 className="text-xl font-bold mb-4">{t('pages:contactInformation')}</h2>
          <p className="text-gray-600">{t('pages:contactInformationBody')}</p>
        </div>
      </div>
    </div>
  )
}

export default Content
